import IFilter from './IFilter'
import EmptyFilter from './EmptyFilter'
import {getMongoOperator} from "./utils/mongo.utils";
import ObjectIdFactory from "./ObjectIdFactory";
import TermFilter from "./TermFilter";

/**
 * This class handle the Term Filters
 * @author Yadian
 * Example
 *  {
 "type": "TERM",
 "field": "um.id.keyword",
 "value": "bb4cd88-c6b8-4a77-956a-0671189be008"
 }
 **/


export default class AdvanceTermFilter extends IFilter {

  /**
   * @param filter {Object}
   **/
  constructor(filter) {
    super()
    const {field, value, objectId, isDate, type} = filter
    this.type = type
    this.field = field
    this.value = value
    this.filterObject = filter
    this.objectId = objectId || false
    this.isDate = isDate || false
  }

  clone() {
    return new TermFilter(this.toQuery())
  }

  toQuery() {
    if (!this.field)
      return this.filterObject

    if (this.value === undefined)
      return
    return {
      type: this.type,
      field: this.field,
      value: this.value,
      objectId: this.objectId,
      isDate: this.isDate,
    }
  }

  toMongoQuery() {
    if (!this.field)
      return this.filterObject
    let nValues = this.value
    if (this.objectId) {
      nValues = ObjectIdFactory.create(nValues)
    }
    if (this.isDate && Date.parse(nValues)) {
      nValues = new Date(nValues)
    }
    return {[this.field]: {[getMongoOperator(this.type)]: nValues}}
  }

  removeFilter(filter) {
    if (!!filter && this.field === filter.field)
      return new EmptyFilter()
    return this
  }
}
